import { Link } from 'react-router-dom';
import Header from '@/components/feature/Header';
import Footer from '@/components/feature/Footer';
import Seo from '@/components/seo/Seo';

export default function CorporateHotelCompletePage() {
  return (
    <>
      <Seo route="/corporate/hotel/complete" />
      <Header />
      <main className="pt-[120px] min-h-screen flex items-center justify-center bg-background-50">
      <div className="max-w-[600px] mx-auto px-8 py-20 text-center">
        <div className="w-16 h-16 rounded-full bg-accent-500/10 border border-accent-500/30 flex items-center justify-center mx-auto mb-8">
          <i className="ri-check-line text-accent-500 text-2xl"></i>
        </div>

        <h1 className="font-heading text-xl md:text-2xl text-foreground-900 tracking-[0.06em] mb-4">
          お問い合わせありがとうございます
        </h1>

        <p className="text-[16px] text-foreground-600 tracking-[0.04em] leading-relaxed mb-3">
          担当者より2営業日以内にご連絡いたします。
        </p>

        <p className="text-[14px] text-foreground-400 tracking-[0.04em] leading-relaxed mb-10">
          お急ぎの場合は、お電話{' '}
          <a href="tel:0368244086" className="text-foreground-700 font-medium hover:text-accent-600 transition-colors">
            03-6824-4086
          </a>
          {' '}（受付時間: 平日 10:00〜17:00）までお問い合わせください。
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/corporate/hotel"
            className="px-8 py-3 bg-accent-500 hover:bg-accent-400 text-primary-900 text-[15px] tracking-[0.08em] font-medium transition-all duration-300 whitespace-nowrap"
          >
            ページへ戻る
          </Link>
          <Link
            to="/"
            className="px-8 py-3 border border-background-200/60 text-foreground-500 text-[15px] tracking-[0.08em] hover:text-accent-600 hover:border-accent-500/30 transition-all duration-300 whitespace-nowrap"
          >
            ホームへ戻る
          </Link>
        </div>
      </div>
    </main>
      <Footer />
    </>
  );
}